import React from 'react';
import Card from './card';

export default function GrilldBurgerBucks() {
  return (
    <div className="grilld">
      <Card
        title="Burger Bucks"
        className="burger-bucks"
        prefix="GBB"
      />
    </div>
  );
}
